import { Outlet } from "react-router-dom";
import DashBoard from "../../components/controls/Dashboard/DashBoard";
import { MenuBar } from "../../components/controls/MenuBar/MenuBar";
import accountService, {
  AccountCacheService as AccountRepository,
} from "../../services/accountService";

export default function MainApp() {
  const getInitData = async () => {
    const initData = await accountService.getInitData();
    if (initData !== undefined && initData != null) {
      var accountRepository = new AccountRepository();
      accountRepository.setAccountTypes(initData.accountTypes);
      accountRepository.setAccountGroups(initData.accountGroups);
      accountRepository.setTransactionTypes(initData.transactionTypes);
      accountRepository.setCurrencies(initData.currencies);
      accountRepository.setMarketers(initData.accountMarketers);
      accountRepository.setOfficers(initData.accountOfficers);
    }
  };

  getInitData();

  return (
    <>
      {/* <AlertContext.Provider value={{} }> */}
      <MenuBar />
      <main className="container">
        <div className="row" style={{ paddingTop: ".75rem" }}>
          <div className="col col-md-3 hidden-xs">
            <div className="row">
              <div className="col">
                <DashBoard />
              </div>
            </div>
            <div className="row">
              <div className="col">
                <div className="list-group mt-2">
                  <div className="list-group-item">
                    <div className="d-flex w-100 justify-content-between">
                      <h6 className="mb-1">View Analytics</h6>
                    </div>
                    <p className="mb-1 text-bold">10,000</p>
                    <small>
                      <a href="#" className="btn-sm text-secondary">
                        View Details
                      </a>
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col col-md-9 col-xs-12">
            <Outlet />
          </div>
        </div>
      </main>
      {/* </AlertContext.Provider> */}
    </>
  );
}
